import { Injectable } from '@angular/core';

import { HealthCareServiceAPIResponse, Healthcareservice } from '../interfaces/healthcareservice';

@Injectable({
  providedIn: 'root',
})
export class HealthcareServiceAdapter {
  public adapterToModel(healthcareFHIR: HealthCareServiceAPIResponse): Healthcareservice {
    return {
      healthcareservice_id: healthcareFHIR.healthcareservice_id,
      name: healthcareFHIR.name,
      tuss_code: healthcareFHIR?.tuss_code,
      specialty_code: healthcareFHIR?.specialty_code || healthcareFHIR?.specialty?.[0]?.coding?.[0]?.code,
      description: healthcareFHIR.description,
      organization: {
        organization_id: healthcareFHIR.providedBy.code,
        name: healthcareFHIR.providedBy.display,
      },
      extraDetails: healthcareFHIR.extraDetails,
      type: healthcareFHIR?.type[0]?.coding[0]?.display,
      price_low: this.amountFromPagarme(healthcareFHIR.valueRange.low.value),
      price_high: this.amountFromPagarme(healthcareFHIR.valueRange.high.value),
      status: healthcareFHIR.status,
      comments: healthcareFHIR.comments,
      appointmentRequired: healthcareFHIR.appointmentRequired,
      active: healthcareFHIR.active,
      serviceType: healthcareFHIR.serviceType,
      serviceDealer: healthcareFHIR.serviceDealer,
      location: healthcareFHIR.location,
    };
  }

  adaptToAPIFormat(healthcare: Healthcareservice): HealthCareServiceAPIResponse {
    return {
      healthcareservice_id: healthcare.healthcareservice_id,
      name: healthcare.name,
      tuss_code: healthcare?.tuss_code,
      specialty_code: healthcare.specialty_code || healthcare.tuss_code,
      description: healthcare.description,
      extraDetails: healthcare.extraDetails ?? '',
      comments: healthcare.comments,
      valueRange: {
        low: {
          value: this.amountToPagarme(healthcare.price_low || healthcare.price_high),
          currency: 'BRL',
        },
        high: {
          value: this.amountToPagarme(healthcare.price_high),
          currency: 'BRL',
        },
      },
      status: healthcare.status,
      providedBy: {
        reference: `Organization/${healthcare.organization.organization_id}`,
        code: healthcare.organization.organization_id,
        display: healthcare.organization.name,
      },
      type: [
        {
          coding: [
            {
              system: 'http://snomed.info/sct',
              code: '394913002',
              display: healthcare.type,
            },
          ],
        },
      ],
      specialty: [
        {
          coding: [
            {
              system: '',
              code: healthcare.specialty_code || healthcare.tuss_code || '',
              display: healthcare.specialty ?? healthcare.name,
            },
          ],
        },
      ],
      appointmentRequired: healthcare.appointmentRequired,
      active: healthcare.active,
      serviceType: healthcare.serviceType,
      serviceDealer: healthcare.serviceDealer,
    };
  }

  private amountToPagarme(value: string | number | null | undefined): number {
    if (typeof value === 'number') {
      return Math.round(value * 100);
    }

    const normalized = String(value ?? '')
      .trim()
      .replace(/[R$\s]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');
    const amount = Number(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  private amountFromPagarme(value: string | number | null | undefined): string {
    const cents = Number(value ?? 0);

    if (!Number.isFinite(cents)) {
      return '';
    }

    return (cents / 100).toFixed(2);
  }
}
